import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { SingleDatePicker } from "react-dates";
import moment from "moment";
import useCheckboxes from "../../Hooks/useCheckboxes";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import AcademicCalendarService from "../../../Services/AcademicCalendar.service";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import useUniqueId from "../../Hooks/useUniqueId";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import DateService from "../../../Services/Shared/Date.service";
const PAGE_SIZE = 20;
const SEARCH_DEFAULT = "";
// @ts-expect-error - TS2739 - Type '{ query: string; }' is missing the following properties from type 'Search': startDateTo, startDateFrom, endDateTo, endDateFrom
const DEFAULT_SEARCH = {
    query: SEARCH_DEFAULT,
};
// @ts-expect-error - TS2739 - Type '{ id: string; name: string; }' is missing the following properties from type 'AcademicCalendarDto': displayName, startDate, endDate, year
const CURRENT_TERM = {
    id: "0",
    name: "Current Term",
};
const AcademicCalendarLookup = ({ selected: selectedAcademicCalendarDto, onApply, children, includeCurrentDefault, futureTermsOnly, }) => {
    var _a;
    const [startDateToFocused, setStartDateToFocused] = React.useState(false);
    const [startDateFromFocused, setStartDateFromFocused] = React.useState(false);
    const [endDateToFocused, setEndDateToFocused] = React.useState(false);
    const [endDateFromFocused, setEndDateFromFocused] = React.useState(false);
    const [includeCurrent, setIncludeCurrent] = React.useState(includeCurrentDefault || false);
    const [filtersState, setFiltersState] = React.useState({ startDate: null, endDate: null });
    const [query, setQuery] = React.useState(SEARCH_DEFAULT);
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const [validationError, setValidationError] = React.useState(null);
    const makeId = useUniqueId()[1];
    const searchItems = () => {
        setValidationError(null);
        setSearchArgs({
            query,
            startDateFrom: filtersState.startDateFrom,
            startDateTo: filtersState.startDateTo,
            endDateFrom: filtersState.endDateFrom,
            endDateTo: filtersState.endDateTo,
        });
    };
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedAcademicCalendarDto || [],
        // eslint-disable-next-line eqeqeq
        equalsFunc: (a, b) => a.id == b.id,
    });
    const { table, dataState } = usePagedSortedTable({
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            getCheckedItem: (data, index) => {
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                return data.data[index];
            },
        },
        getData: (sort, page, sArgs) => {
            return AcademicCalendarService.lookupSearch({
                names: [sArgs.query],
                startDateFrom: futureTermsOnly
                    ? moment(Date.now())
                    : sArgs.startDateFrom,
                startDateTo: sArgs.startDateTo,
                endDateTo: sArgs.endDateTo,
                endDateFrom: sArgs.endDateFrom,
            }, {
                max: PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                offset: page * PAGE_SIZE,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            }).then((data) => {
                return includeCurrent && page === 0
                    ? Object.assign(Object.assign({}, data), { data: [CURRENT_TERM, ...data.data] }) : Object.assign(Object.assign({}, data), { data: [...data.data] });
            });
        },
        searchArgs,
        getNumPages: (result) => {
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
            return TotalPageMappers.EngagePagedResult(result, PAGE_SIZE);
        },
        noDataComponent: "No Terms found",
        initialSort: { sort: "ACADEMICCALENDARSTARTDATE", order: "desc" },
        columns: [
            {
                title: "Name",
                sortId: "ACADEMICCALENDARNAME",
            },
            {
                title: "Starts",
                sortId: "ACADEMICCALENDARSTARTDATE",
            },
            { title: "Ends", sortId: "ACADEMICCALENDARENDDATE" },
            {
                title: "Year",
                sortId: "ACADEMICCALENDARYEAR",
            },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => 
        // @ts-expect-error - TS7006 - Parameter 'academicCalendarDto' implicitly has an 'any' type.
        data.map((academicCalendarDto) => {
            return [
                academicCalendarDto.name,
                academicCalendarDto.startDate
                    ? DateService.displayLong(new Date(academicCalendarDto.startDate))
                    : null,
                academicCalendarDto.endDate
                    ? DateService.displayLong(new Date(academicCalendarDto.endDate))
                    : null,
                academicCalendarDto.year,
            ];
        }),
    });
    return children({
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        lookup: (_jsxs(_Fragment, { children: [validationError && _jsx(AlertError, { message: validationError }), _jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "academicCalendarSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "academicCalendarSearch", placeholder: "Search Name", style: { width: 200 }, value: query, onChange: (event) => {
                                        setQuery(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: makeId("updatedFromDate"), className: "sr-only", children: "Start Date From" }), _jsx("label", { htmlFor: makeId("updatedToDate"), className: "sr-only", children: "Start Date To" }), _jsxs("div", { className: "d-flex react-date-single-picker-group", id: "startGroup", children: [_jsx(SingleDatePicker, { showClearDate: true, displayFormat: "M/D/YYYY", numberOfMonths: 1, 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: filtersState.startDateFrom, id: makeId("updatedFromDate"), placeholder: "Starts from", onDateChange: (date) => {
                                                if (!date && !filtersState.startDateFrom) {
                                                    return date;
                                                }
                                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { startDateFrom: date })));
                                                const { startDateTo } = filtersState;
                                                if (startDateTo && !startDateTo.isAfter(date)) {
                                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { startDateTo: date })));
                                                }
                                                return date;
                                            }, focused: startDateFromFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setStartDateFromFocused(focused), small: true }), _jsx(SingleDatePicker, { numberOfMonths: 1, showClearDate: true, displayFormat: "M/D/YYYY", id: makeId("updatedToDate"), placeholder: "Starts to", 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: filtersState.startDateTo, onDateChange: (date) => {
                                                if (!date && !filtersState.startDateTo) {
                                                    return date;
                                                }
                                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { startDateTo: date })));
                                                const { startDateFrom } = filtersState;
                                                if (startDateFrom && !startDateFrom.isBefore(date)) {
                                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { startDateFrom: date })));
                                                }
                                                return date;
                                            }, focused: startDateToFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setStartDateToFocused(focused), small: true })] })] }), _jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: makeId("updatedEndFromDate"), className: "sr-only", children: "End Date From" }), _jsx("label", { htmlFor: makeId("updatedEndFromDate"), className: "sr-only", children: "End Date To" }), _jsxs("div", { className: "d-flex react-date-single-picker-group", id: "endGroup", children: [_jsx(SingleDatePicker, { showClearDate: true, displayFormat: "M/D/YYYY", numberOfMonths: 1, 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: filtersState.endDateFrom, id: makeId("updatedEndFromDate"), placeholder: "Ends from", onDateChange: (date) => {
                                                if (!date && !filtersState.endDateFrom) {
                                                    return date;
                                                }
                                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { endDateFrom: date })));
                                                const { endDateTo } = filtersState;
                                                if (endDateTo && !endDateTo.isAfter(date)) {
                                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { endDateTo: date })));
                                                }
                                                return date;
                                            }, focused: endDateFromFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setEndDateFromFocused(focused), small: true }), _jsx(SingleDatePicker, { numberOfMonths: 1, displayFormat: "M/D/YYYY", showClearDate: true, id: makeId("updatedEndToDate"), placeholder: "Ends to", 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: filtersState.endDateTo, onDateChange: (date) => {
                                                if (!date && !filtersState.endDateTo) {
                                                    return date;
                                                }
                                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { endDateTo: date })));
                                                const { endDateFrom } = filtersState;
                                                if (endDateFrom && !endDateFrom.isBefore(date)) {
                                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { endDateFrom: date })));
                                                }
                                                return date;
                                            }, focused: endDateToFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setEndDateToFocused(focused), small: true })] })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
    });
};
export default AcademicCalendarLookup;
